<template>
    <div class="filter__wrapper">
        <h2 class="filter__wrapper--headline">&nbsp;</h2>
        <ul class="filter__wrapper--filters">
            <li v-for="entry in 5"
                :key="entry">
                <span class="checkbox--fake"></span>
                <label >&nbsp;</label>
            </li>
        </ul>
    </div>
</template>


<style scoped>
    .filter__wrapper--headline,
    .checkbox--fake,
    label{
        animation: pulse 2s infinite !important;
    }

    @keyframes pulse {
        0% {
            background-color: #F9F9F9;
        }

        70% {
            background-color: #FAFAFA;
        }

        100% {
            background-color: #F9F9F9;
        }
    }
    .filter__wrapper{
        padding-bottom: 55px;
    }
    .filter__wrapper--headline{
        margin: 0;
        font-size: 23px;
        line-height: 30px;
        color: #000000;
        margin-bottom: 25px;
        font-weight: normal;
    }
    .filter__wrapper--filters{
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .filter__wrapper--filters li{
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
    }
    .filter__wrapper--filters li .checkbox--fake{
        background-color: #575C61;
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        padding: 2px;
        box-sizing: border-box;
    }
    .filter__wrapper--filters li .checkbox--fake svg{
        vertical-align: top;
    }
    .filter__wrapper--filters li input{
        width: 16px;
        height: 16px;
        border: 1px solid #979797;
        background-color: rgba(255, 255, 255, 0.7);
        appearance: none;
        outline: none;
        margin: 0;
        vertical-align: middle;
        cursor: pointer;
    }
    .filter__wrapper--filters li input[type="radio"] {
        border-radius: 50%;;
    }
    .filter__wrapper--filters li .checkbox--fake.radio{
        border-radius: 50%;
        background: white;
        border: 1px solid #979797;
    }
    .filter__wrapper--filters li .checkbox--fake.radio .bullet{
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 50%;
        background-color: #575C61;
    }
    .filter__wrapper--filters li label{
        font-size: 16px;
        color: #575C61;
        line-height: 22px;
        vertical-align: middle;
        margin-left: 7px;
        width: 70%;
        display: inline-block;
        cursor: pointer;
    }
    .star__wrapper{
        font-size: 0;
        line-height: 0;
        padding-top: 1px;
    }

    .star__wrapper span{
        padding-right: 5px;
    }

    .star__text{
        font-size: 16px;
        line-height: 22px;
    }
</style>